import { type FC } from "react";

import { Dialog } from "@fronterahealth/frontera-ui-components";

import { PromptReportTypeMismatchList } from "@pages/Templates/PromptReportTypeMismatchList";
import { type PromptReportTypeMismatch } from "@pages/Templates/promptReportType";

export const PromptReportTypeMismatchDialog: FC<{
  open: boolean;
  mismatches: readonly PromptReportTypeMismatch[];
  reportType: string;
  onConfirm: () => void;
  onCancel: () => void;
}> = ({ open, mismatches, reportType, onConfirm, onCancel }) => (
  <Dialog
    title="AI prompts don't match the template type"
    open={open}
    setOpen={(isOpen) => {
      if (!isOpen) onCancel();
    }}
    primaryButton={{ text: "Save anyway", onClick: onConfirm }}
    secondaryButton={{ text: "Go back", onClick: onCancel }}
    size="xl"
  >
    <PromptReportTypeMismatchList mismatches={mismatches} reportType={reportType} />
  </Dialog>
);
